module.exports = __webpack_public_path__ + "static/media/image-9.85561062.png";